import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcode";
import { DOMAIN } from "../../global";
import headerImage from "../image/visibleSafety/letterHead.png";
// import footerImage from "../image/visibleSafety/footer_VCC1.png";
import vssLogo from "../image/visibleSafety/watermark.png";
import Sign from "../image/visibleSafety/sign.png";

let config = {
  margin: 20,
  borderMagin: 3,
  fontSize: 8.5,
  bordergap: 3,
  currentY: 0,
  headerHeight: 96,
  footerheight: 50
};

const generateStaticSection = (doc, formInfo, inputStates, extraprops) => {
  const is13 = formInfo?.name?.includes("Section-29");
  const bgColor = "FFFFFF";
  const textColor = "#000000";

  const parsedTitle = formInfo?.title ? JSON.parse(formInfo.title) : {};
  const rule = parsedTitle?.rule || "";
  const title = parsedTitle?.title || "";

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [40, 60];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  // First row - Title section with background color
  //   autoTable(doc, {
  //     startY: config.headerHeight + 5,
  //     margin: { left: config.margin, right: config.margin },
  //     theme: "plain",
  //     body: [
  //       [
  //         {
  //           content: `Certificate No.-${extraprops?.certificateNo || ""}`,
  //           //   colSpan: 4,
  //           styles: {
  //             halign: "left",
  //             fontSize: config.fontSize + 2,
  //           },
  //         },
  //         {
  //           content: `${
  //             formInfo?.branchId == 15
  //               ? "Competency No:- CMP-618/2023 ,  Dated:08/01/2024 Valid up to 31/12/2024"
  //               : ""
  //           }`,
  //           //   colSpan: 4,
  //           styles: {
  //             halign: "left",
  //             fontSize: config.fontSize + 2,
  //           },
  //         },
  //       ],
  //     ],
  //     styles: {
  //       fontSize: config.fontSize,
  //       textColor: 0,
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.5,
  //       valign: "middle",
  //       fontStyle: "normal",
  //       cellPadding: { top: 2, bottom: 2, left: 0, right: 2 },
  //     },
  //     columnStyles: {
  //       0: { cellWidth: columnWidths[0] },
  //       1: { cellWidth: columnWidths[1] },
  //     },
  //   });

  // Second TableRow: Report number, right-aligned
  autoTable(doc, {
    startY: config.headerHeight + 3,
    body: [
      [
        {
          content: (formInfo?.name || "").toUpperCase(),
          styles: {
            fillColor: bgColor,
            textColor: textColor,
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            fontSize: config.fontSize + 2.5,
            cellPadding: { top: 7, bottom: 2, left: 5, right: 5 },
          },
        },
      ],
      //   [
      //     {
      //       content: rule,
      //       styles: {
      //         fillColor: bgColor,
      //         textColor: textColor,
      //         halign: "center",
      //         valign: "middle",
      //         fontStyle: "bold",
      //         fontSize: config.fontSize,
      //         cellPadding: { top: 2, bottom: 2, left: 5, right: 5 },
      //       },
      //     },
      //   ],
      //   [
      //     {
      //       content: title,
      //       styles: {
      //         fillColor: bgColor,
      //         textColor: textColor,
      //         halign: "center",
      //         valign: "middle",
      //         fontStyle: "bold", // applies bold and normal
      //         fontSize: config.fontSize,
      //         cellPadding: { top: 2, bottom: 5, left: 5, right: 5 },
      //       },
      //     },
      //   ],
    ],
    theme: "plain",
    margin: { left: config.margin + 25, right: config.margin + 25 },
    didDrawCell: function (data) {
      if (data.section === 'body') {
        const cell = data.cell;
        const text = cell.text;
        // Get font properties
        doc.setFont(doc.getFont().fontName, 'bold');
        doc.setFontSize(config.fontSize + 3);
        // Calculate line height
        const lineHeight = (config.fontSize + 3) * 1;
        // Draw underline for each line of text
        text.forEach((line, index) => {
          if (line.trim()) {
            const textWidth = doc.getTextWidth(line);
            const startX = cell.x + (cell.width - textWidth) / 2; // Center aligned
            const lineY = cell.y + cell.styles.cellPadding.top + (index + 1) * lineHeight + 1;
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.5);
            doc.line(startX, lineY, startX + textWidth, lineY);
          }
        });
      }
    }
  });

 // Third TableRow: Report number, right-aligned
  autoTable(doc, {
    startY: doc.lastAutoTable?.finalY + 2,
    margin: { left: config.margin, right: config.margin },
    theme: "plain",
    body: [
      [
        {
          content: `Report No: ${inputStates?.reportNumber || ""}`,
          colSpan: 4,
          styles: {
            halign: "right",
            fontStyle: "bold",
            fontSize: config.fontSize - 1,
            cellPadding: { top: 2, bottom: 0, left: 0, right: 2 },
          },
        },
      ],
    ],
  });
};

const generateDynamicTableSection = (
  doc,
  filteredInputFields,
  inputStates,
  Factory,
  Shop,
  Product
) => {
  const body = [];

  filteredInputFields?.forEach((field) => {
    if (field?.stateKey === "companyName") return;
    if (field?.stateKey === "certificateNumber" || field?.stateKey === "conclusionOfCertificate" || field?.stateKey === "inspectedOn") return;

    let label = field?.label || "";
    const numberMatch = label.match(/^\d+(\.\s|[a-z]\) )/);
    const number = numberMatch ? numberMatch[0].trim() : "";
    let restLabel = label.replace(number, "").trim();
    if (restLabel === "Address of the Factory") {
      restLabel = "Name and address of the Factory";
    }

    let value = "";

    if (field?.stateKey === "factoryId") {
      const factory = Factory?.find((ele) => ele.id === inputStates?.factoryId);
      value = `${factory?.name || ""}`;
    } else if (field?.stateKey === "shopId") {
      const shop = Shop?.find((ele) => ele.id === inputStates?.shopId);
      value = shop?.name || "";
    } else if (field?.stateKey === "equipmentId") {
      const product = Product?.find(
        (ele) => ele.id === inputStates?.equipmentId
      );
      value = product?.name || "";
    } else if (field?.type === "DatePicker") {
      const date = inputStates?.[field?.stateKey];
      value = date ? new Date(date).toLocaleDateString("en-GB") : "";
    } else {
      value = inputStates?.[field?.stateKey] || "";
    }

    body.push([
      {
        content: number,
        styles: {
          //   fillColor: "#d9d9d9",
          halign: "center",
          valign: "top",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2 },
        },
      },
      {
        content: restLabel,
        styles: {
          //   fillColor: "#fff2cd",
          halign: "left",
          valign: "top",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2, left: 5, right: 3 },
        },
      },
      {
        content: ":",
        styles: {
          //   fillColor: "#d9d9d9",
          halign: "center",
          valign: "top",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2 },
        },
      },
      {
        content: value,
        styles: {
          //   fillColor: "#fff2cd",
          halign: "left",
          valign: "top",
          fontSize: config.fontSize,
          cellPadding: { top: 2, bottom: 2, left: 5, right: 3},
        },
      },
    ]);
  });

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [2.5, 48, 2, 47.4];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  autoTable(doc, {
    startY: doc.lastAutoTable?.finalY + 5,
    margin: { left: config.margin, right: config.margin },
    body: body,
    theme: "plain",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0,
      valign: "top",
      fontStyle: "normal",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
  });
};

const generateSignatureSectionPDF = async ({
  doc,
  inputStates,
  extraprops,
  formInfo,
  letterHead
}) => {
  const getFormattedDate = () => {
    const today = inputStates?.reportDate
      ? new Date(inputStates?.reportDate)
      : new Date();
    return today.toLocaleDateString("en-GB");
  };

  const getNextYearDate = () => {
    const today = inputStates?.reportDate
      ? new Date(inputStates?.reportDate)
      : new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);
    const formattedNextYearDate = inputStates?.certificateValidity
      ? moment(inputStates?.certificateValidity).format("DD/MM/YYYY")
      : nextYear.toLocaleDateString("en-GB");

    return formattedNextYearDate;
  };

  let certificationNote = [
    {
      id: 5,
      label:
        "I/We certify that on {date} I/We thoroughly examined the above mentioned dangerous machine and found working satisfactorily and the above is a correct report of the result.",
      fontSize: config.fontSize - 1.1,
    },
    {
      id: 14,
      fontSize: config.fontSize - 0.9,
      label: `I/We certify that on ${getFormattedDate()} I/We thoroughly examined the above mentioned lifting Tools/machine/ chain/lifting tackle. It is found satisfactory and that the above is a correct report of the result.

* Term "Satisfactory" mentioned in result column means satisfactory load part of lifting appliance found during examination.

* ID No. SWL, test date, next testing due date to be painted/ displayed on the equipment. The equip./install. should be strictly in accordance with Sec 29    of F.A. (may be referred by the user). Any violation of the same makes this certificate invalid.

* Proper care should be taken so that jerking / shock loading of equipment does not take place, as it may lead to sudden / abrupt failure of vital                 Component.  The equipment tested was found OK at the time  of resting.  Due to wear & tear,  repair and maintenance  if any failure of equipment            occurs, it is sole responsibility of O.E.M. and not the undersigned and he can not be held responsible for any failure after testing date and time

* Welding ofhook, pulley, pins ete is not permitted Any worn -out hook. Pulley, pins etc to be replaced immediately & retesting to be done.

* Cranes/ Hoist should have Hoist/ Boom/CT limit switches for better safety & should be maintained in working condition all the time.
  This certificate is only an equipment fitness certificate issued after examination and testing as per statutory provisions and it should not be treated as   a "Quality Assurance" certificate pertaining to Design, Material of construction or welding etc. Clause 62(1), and 66 indicate load testing before  first       use and after repair, respectively.

* Clause 65(2) a (iii) (1) indicates periodic thorough examination by a Competent Person in every period of 12 months. Where as thorough examination     is defined as "thorough visual examination" of the eq. if required by dismantling the parts,  so far as condition permits,  so as to arrive at stable              conclusion.

* Any discrepancy related to the Certificate shall be informed with him 7 days from the date or issue of Certificate other wise it shall be deemed  to  be     correct/accepted by you and no claims shall be entertained thereafter. Any kind of tampering, editing overlapping over writing or misrepresentation       by use of software like photoshop, paintbrush shall attract suitable legal action as per Indian law. Photocopy submitted shall be verified with original     Certificate.

* Daily check list & maint log book to be essentially maintained with signature of person responsible for same.

* Issued subject to condition that equipment is maint, in proper condition. All the movable parts i.e. lock/pin/shafts etc. Are checked regularly &                replaced with genuine spares only.

* validity : up to ${moment(inputStates?.certificateValidity).subtract(1, "days").format("DD/MM/YYYY")} or date of repair whichever is earlier, NEXT TEST DUE : ${moment(inputStates?.certificateValidity).format("DD/MM/YYYY")}`
    },
    {
id: 15,
fontSize: config.fontSize - 2.5,
label: `I, certify that on ${getFormattedDate()} the pressure vessel described above was thoroughly cleaned and (so far as its construction permits) made accessible for thorough examination and for such tests as were necessary for thorough examination and that on the said date, I thoroughly examined this pressure vessel, including its fittings and that the above is a true report of my examination.

Validity: 6 months (PV): up to ${moment(inputStates?.certificateValidity).subtract(1, "days").format("DD.MM.YYYY")} or date of repair which ever is earlier, NEXT TEST DUE: ${moment(inputStates?.certificateValidity).format("DD.MM.YYYY")}

Index: SV: Safety Valve, PG: Pressure Gunge, DV: Drain Valve, PS: Pressure Switch, IV: Isolation Valve

ID No, SWP, test date to be displayed on the equipment. The equipt installn should be strictly in accordance with see 31 of Factories Act. Any violation of the same makes this certificate invalid Hydraulic test is recommended in every 2/4 years for inaccessable/accessible vessels respectively.

Any discrepancy related to this certificate should be informed within seven days from the issue date of this certificate, otherwise it shall be deemed to be correct, accepted by you & no claim shall be entertained thereafter. Any of tempering/editing, overlapping, copying, overwriting or misrepresentation by use of software like photo shop, paintbrush shall attract suitable legal action as per Indian law. Photocopy submitted shall be verified from original certificate.

Proper care should be taken while fitting the top cap and no tempering should be done in original fitment. Eroded pipes should be immediately replaced with new one of same material. Any repair/ welding/Patch work on tank makes the certificate invalid and should be offered for inspection.`
}, 
{
  id:16,
  fontSize: config.fontSize - 1.1,
  label: `I certify that on dated ${getFormattedDate()}, I thoroughly examined the lift and that the above is a correct report ofthe result.`
},
{
  id:17,
  fontSize: config.fontSize,
  label: `I certify that on dated ${getFormattedDate()}, I thoroughly examined the hoist and that the above is a correct report ofthe result.

* This Certificate is only an equipment fitness certificate issued after examination and testing as per statutory provisions & it should not      be treated as “Quality Assurance" Certificate pertaiming to Design, material of construction or welding etc.

* Term "Satisfactory" mentioned in result Columns means satisfactory load partof lifting appliance found during examination.

* ID No. SWL, test date to be painted/ displayed on equipment. The equipment should be maintained strictly in accordance with section -    28 of Factories Act 1948 and state rules framed there under.

  * Validity: (6 months) up to ${moment(inputStates?.certificateValidity).subtract(1, "days").format("DD.MM.YYYY")} or date of repairwhichever is eartier. NEXT TEST DUE : ${moment(inputStates?.certificateValidity).format("DD.MM.YYYY")}
  `
},
  ];

  const selectedTemplate = certificationNote.find((template) => template.id == extraprops?.newTemplateID);
  // Format the date
  const formattedDate = getFormattedDate();
  const paragraphText = selectedTemplate
    ? selectedTemplate.label.replace(/{date}/g, formattedDate)
    : "";
  const finalY = doc.lastAutoTable.finalY + 2;
  autoTable(doc, {
    startY: finalY,
    margin: { left: config.margin, right: config.margin },
    body: [
      [
        {
          content: paragraphText,
          styles: {
            halign: "left",
            cellPadding: 2,
            fontStyle: "bold",
            fontSize: selectedTemplate?.fontSize || config.fontSize - 1.1,
          },
        },
      ],
      //   [
      //     {
      //       content: `Next inspection due on: ${getNextYearDate()}`,
      //       styles: {
      //         halign: "justify",
      //         cellPadding: 1,
      //         fontStyle: "bold",
      //       },
      //     },
      //   ],
    ],
    theme: "plain",
    // styles: {
    //   fontSize: config.fontSize + 1.1,
    // },
  });

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [10, 39, 2, 5, 54];
  // Calculate the actual column widths based on percentages
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  // Prepare autoTable
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 3,
    margin: { left: config.margin, right: config.margin },
    body: [
      [
        {
          content: "",
          rowSpan: 4,
          styles: { fillColor: false, halign: "left" },
        },
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        {
          content: "",
          styles: {
            minCellHeight: 20,
          },
        },
        {
          content: "",
          rowSpan: 6,
          styles: {
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
      [
        {
          content: "",
          styles: {
            fillColor: false,
            halign: "right",
            fontSize: config.fontSize - 1,
            fontStyle: "bold",
          },
        },
        { content: "", styles: { fillColor: false, halign: "center" } },
        { content: "" },
      ],
    ],
    theme: "plain",
    styles: {
      fontSize: config.fontSize,
      cellPadding: { top: 2, left: 5, bottom: 2, right: 5 },
      valign: "middle",
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0,
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
    },

    didDrawCell: (data) => {
      if (data.column.index === 4) {
        let { x, y, width, height } = data.cell;
        const imageHeight = height - 5;
        const halfWidth = width / 2;
        const imageSize = height;

        // Signature on the left half
        if (extraprops?.competentPerson?.signPath && letterHead) {
          const signatureX = x;
          const signatureY = y + (height - imageHeight) / 2;
          const scaleFactor = 0.8;  // 80% of the original size

          doc.addImage(
            extraprops?.competentPerson?.signPath,
            "PNG",
            signatureX + 30,
            signatureY + 20,
            (halfWidth - 20) * scaleFactor,
            (imageHeight - 30) * scaleFactor
          );
        }
        // Stamp on the right half
        if (extraprops?.competentPerson?.stampPath && letterHead) {
          const centerX = x + (width - imageSize) / 2;
          const centerY = y + (height - imageSize) / 2;

          doc.addImage(
            extraprops?.competentPerson?.stampPath || "",
            "PNG",
            centerX + 10,
            centerY,
            imageSize,
            imageSize
          );
        }

        // Draw text below the image
        const textX = x + width / 2;
        const textY = y + imageHeight + 10;

        doc.setFontSize(config.fontSize + 1);
        doc.setFont(undefined, "bold");
        doc.text(extraprops?.competentPerson?.personName, textX, textY, {
          align: "center",
        });

        doc.setFont(undefined, "bold");
        doc.setFontSize(config.fontSize + 1);
        doc.text("Competent Person\n" + (extraprops?.competentPerson?.qualification || ""), textX, textY + 8, {
          align: "center",
        });
      }
      // sign img
      //   if (
      //     data.column.index === 3 &&
      //     data.row.index === 0 &&
      //     selectedOption?.signPath
      //   ) {
      //     const { x, y, width, height } = data.cell;
      //     const imageSize = height - 5;
      //     const centerX = x + 5;
      //     const centerY = y + (height - imageSize) / 2;

      //     doc.addImage(
      //       selectedOption?.signPath || "",
      //       "PNG",
      //       centerX,
      //       centerY,
      //       imageSize + 50,
      //       imageSize
      //     );
      //   }

      //   qr code
      if (data.column.index === 0 && data.row.index === 0) {
        const { x, y, width, height } = data.cell;
        const imageSize = height - 10;
        const centerX = x + (width - imageSize) / 2;
        const centerY = y + (height - imageSize) / 2;
        const qrCodeUrl = `${DOMAIN}/#/printForm/${extraprops.newReportID}/${extraprops.newTemplateID}/print`;

        QRCode.toDataURL(
          qrCodeUrl,
          { width: 250, height: 250, margin:1 },
          (err, qrCodeUrl) => {
            if (err) return console.error(err);
            doc.addImage(
              qrCodeUrl,
              "PNG",
              centerX,
              centerY + 5,
              imageSize,
              imageSize
            );
          }
        );

        // Add Certificate No and Next Inspection below QR code
        const textX = x + width / 2;
        let textY = centerY + imageSize + 15;

        doc.setFontSize(config.fontSize + 1);
        doc.setFont(undefined, "bold");
        doc.text(
          `Issue Date: ${inputStates?.issueDate ? moment(inputStates?.issueDate).format("DD/MM/YYYY") : ""}`,
          textX - 25,
          textY,
          { align: "left" }
        );

        textY += 13; // space between lines
        doc.text(
          `Place: Bilaspur (CG)`,
          textX - 25,
          textY,
          { align: "left" }
        );

        textY += 13; // space between lines
        // doc.text(
        //   `Next Testing Due on: ${getNextYearDate()}`,
        //   textX - 25,
        //   textY,
        //   { align: "left" }
        // );

      }
    },
  });
};

// for multiple report in one pdf
export async function drawReportOnDoc(
  doc,
  letterHead,
  formInfo,
  inputStates,
  filteredInputFields,
  Factory,
  Shop,
  Product,
  extraprops
) {
  // config.fontSize = /Section[- ]29/.test(formInfo?.name || "") ? 11.5 : 7.5;
  config.fontSize = extraprops?.newTemplateID == 16 ? 7.3 : 8.5;

  //   const totalWidth = doc.internal.pageSize.getWidth();
  //   const totalHeight = doc.internal.pageSize.getHeight();
  //   doc.setDrawColor(0);
  //   doc.setLineWidth(0.3);
  //   doc.rect(
  //     config?.borderMagin + 2,
  //     config?.borderMagin + config.bordergap,
  //     totalWidth - config?.borderMagin * 2 - 2,
  //     totalHeight - config?.borderMagin * 2 - config.bordergap
  //   );
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  // === 1. Add Header Image ===
  const reducedMargin = config.margin / 2 - 10;
  if(letterHead){  
    doc.addImage(
      headerImage,
      "PNG",
      reducedMargin,
      0,
      pageWidth - reducedMargin * 2,
      config.headerHeight
    );

  // === 2. Add Footer Image ===
  //   doc.addImage(
  //     footerImage,
  //     "PNG",
  //     reducedMargin,
  //     pageHeight - config.footerheight,
  //     pageWidth -reducedMargin * 2,
  //     config.footerheight
  //   );

  // === 3. Add Center Logo ===
  const logoWidth = 150;
  const logoHeight = 150;
  const centerX = (pageWidth - logoWidth) / 2;
  const centerY = (pageHeight - logoHeight) / 2;

  doc.addImage(vssLogo, "PNG", centerX, centerY, logoWidth, logoHeight);
 }


  generateStaticSection(doc, formInfo, inputStates, extraprops);

  generateDynamicTableSection(
    doc,
    filteredInputFields,
    inputStates,
    Factory,
    Shop,
    Product
  );


  await generateSignatureSectionPDF({
    doc,
    inputStates,
    extraprops,
    formInfo,
    letterHead
   });
}

// MODIFY generatePDF1 — only its body changes, everything else stays
export function generatePDF1(
  letterHead,
  formInfo,
  inputStates,
  filteredInputFields,
  Factory,
  Shop,
  Product,
  extraprops,
  competentPerson
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });

  drawReportOnDoc(doc, letterHead, formInfo, inputStates, filteredInputFields, Factory, Shop, Product, extraprops)
    .then(() => {
      doc.save(`form.pdf`);
    });
}